import {useHotkeys} from 'react-hotkeys-hook';
import type {ShortcutCommand} from '../types';
import {useShortcuts} from './useShortcuts';

export const useShortcut = <T extends HTMLElement>(
  command: ShortcutCommand,
  action: () => void,
) => {
  const shortcuts = useShortcuts();

  const hotkey = shortcuts ? (shortcuts[command] ?? '') : '';

  // No deps: useHotkeys then calls the latest action instead of a memoized stale one
  return useHotkeys<T>(hotkey, action, {
    // Disable shortcuts without hotkey.
    enabled: !!hotkey,
    // Prevent default browser behavior when hotkey is definded.
    //preventDefault: !!hotkey,
  });
};
